import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";

interface Props {
  children: React.ReactNode;
}

// Lista de rotas isentas de redirecionamento mobile/desktop (Rotas Públicas / Auth)
const EXCLUDED_PATHS = ["/", "/login", "/auth/callback"];

export const ResponsiveRedirectGuard: React.FC<Props> = ({ children }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();

    // 1. Se estiver numa rota de Auth/Pública ou dinâmica como respondToForm, NÃO redireciona
    const isExcluded =
      EXCLUDED_PATHS.includes(currentPath) ||
      currentPath.startsWith("/respondtoform/");

    if (isExcluded) {
      return;
    }

    // 2. Se for Mobile e não estiver na rota /mobile, redireciona
    if (isMobile && !currentPath.startsWith("/mobile")) {
      navigate(`/mobile${location.pathname}${location.search}`, { replace: true });
    } 
    // 3. Se for Desktop e estiver numa rota /mobile, redireciona para a versão Desktop
    else if (!isMobile && currentPath.startsWith("/mobile")) {
      const desktopPath = location.pathname.replace(/^\/mobile/, "") || "/dashboards";
      navigate(`${desktopPath}${location.search}`, { replace: true });
    }
  }, [isMobile, location.pathname, location.search, navigate]);

  return <>{children}</>;
};